import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  createPromoCodeAlias,
  editPromoCodeAlias,
  changePromoCodeAliasPublicationStatus,
  getPromoCodeAliasesDatatable,
  getPromoCodeAliasById,
  getPromoCodeAliasesLookups,
} from './thunks';
import { PromoCodeAliasesState } from './types';

export const name = 'promoCodeAliases';

export const createPromoCodeAliasAsync = createAsyncThunk(
  name + '/createPromoCodeAlias',
  createPromoCodeAlias
);

export const editPromoCodeAliasAsync = createAsyncThunk(
  name + '/editPromoCodeAlias',
  editPromoCodeAlias
);

export const changePromoCodeAliasPublicationStatusAsync = createAsyncThunk(
  name + '/changePromoCodeAliasPublicationStatus',
  changePromoCodeAliasPublicationStatus
);

export const getPromoCodeAliasesDatatableAsync = createAsyncThunk(
  name + '/getPromoCodeAliasesDatatable',
  getPromoCodeAliasesDatatable
);

export const getPromoCodeAliasByIdAsync = createAsyncThunk(
  name + '/getPromoCodeAliasById',
  getPromoCodeAliasById
);

export const getPromoCodeAliasesLookupsAsync = createAsyncThunk(
  name + '/getPromoCodeAliasesLookups',
  getPromoCodeAliasesLookups
);

const initialState: PromoCodeAliasesState = {
  promoCodeAliasesDatatable: {
    data: null,
    status: 'idle',
  },
  promoCodeAliasById: {
    data: null,
    status: 'idle',
  },
  createPromoCodeAlias: {
    data: null,
    status: 'idle',
  },
  editPromoCodeAlias: {
    status: 'idle',
  },
  changePromoCodeAliasPublicationStatus: {
    status: 'idle',
  },
  lookups: {
    data: null,
    status: 'idle',
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearPromoCodeAliasById: (state) => {
      state.promoCodeAliasById.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPromoCodeAliasAsync.pending, (state) => {
        state.createPromoCodeAlias.status = 'loading';
      })
      .addCase(createPromoCodeAliasAsync.fulfilled, (state, action) => {
        state.createPromoCodeAlias = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createPromoCodeAliasAsync.rejected, (state) => {
        state.createPromoCodeAlias.status = 'failed';
      })
      .addCase(editPromoCodeAliasAsync.pending, (state) => {
        state.editPromoCodeAlias.status = 'loading';
      })
      .addCase(editPromoCodeAliasAsync.fulfilled, (state) => {
        state.editPromoCodeAlias.status = 'idle';
      })
      .addCase(editPromoCodeAliasAsync.rejected, (state) => {
        state.editPromoCodeAlias.status = 'failed';
      })
      .addCase(changePromoCodeAliasPublicationStatusAsync.pending, (state) => {
        state.changePromoCodeAliasPublicationStatus.status = 'loading';
      })
      .addCase(
        changePromoCodeAliasPublicationStatusAsync.fulfilled,
        (state) => {
          state.changePromoCodeAliasPublicationStatus.status = 'idle';
        }
      )
      .addCase(changePromoCodeAliasPublicationStatusAsync.rejected, (state) => {
        state.changePromoCodeAliasPublicationStatus.status = 'failed';
      })
      .addCase(getPromoCodeAliasesDatatableAsync.pending, (state) => {
        state.promoCodeAliasesDatatable.status = 'loading';
      })
      .addCase(getPromoCodeAliasesDatatableAsync.fulfilled, (state, action) => {
        state.promoCodeAliasesDatatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPromoCodeAliasesDatatableAsync.rejected, (state) => {
        state.promoCodeAliasesDatatable.status = 'failed';
      })
      .addCase(getPromoCodeAliasByIdAsync.pending, (state) => {
        state.promoCodeAliasById.status = 'loading';
      })
      .addCase(getPromoCodeAliasByIdAsync.fulfilled, (state, action) => {
        state.promoCodeAliasById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPromoCodeAliasByIdAsync.rejected, (state) => {
        state.promoCodeAliasById.status = 'failed';
      })
      .addCase(getPromoCodeAliasesLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getPromoCodeAliasesLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPromoCodeAliasesLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
